export const getPhotoUrl = (photo?: string | null): string | undefined => {
  if (!photo) return undefined;
  let processedPhoto = photo.trim();
  if (processedPhoto.includes('/quicklinks/')) {
    processedPhoto = processedPhoto.replace('/quicklinks/', '/contacts/');
  }

  const isApi = processedPhoto.startsWith('/api');
  return isApi
    ? `${import.meta.env.VITE_SERVICES_URL}${processedPhoto}`
    : processedPhoto;
};
